import { render } from "./ObjectListFields.vue?vue&type=template&id=1005bfaa&scoped=true"
import script from "./ObjectListFields.vue?vue&type=script&lang=js"
export * from "./ObjectListFields.vue?vue&type=script&lang=js"

import "./ObjectListFields.vue?vue&type=style&index=0&id=1005bfaa&lang=scss"
import "./ObjectListFields.vue?vue&type=style&index=1&id=1005bfaa&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1005bfaa"]])

export default __exports__